/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryAPI2
 * @hideconstructor
 * @classdesc API class to construct and run queries.
 */
define([], () => {
	class QueryAPI {

		/**
		 * @public
		 * @function QueryAPI#getSpecList
		 * @description Get the V2 Query Spec which would be sent to the server.
		 * @return {object[]}
		 */
		getSpecList() {}

		/**
		 * @public
		 * @function QueryAPI#execute
		 * @description Execute query with preset parameters.
		 * @async
		 *
		 * @param {Object} [requestOptions] additional request options
		 * @return {Promise<QueryResultAPI[]>} Returns a promise that will be resolved with an array of {@link QueryResultAPI} object.
		 */
		execute() {}


		/**
		 * @public
		 * @function QueryAPI#registerFaultHandler
		 * @description Register a fault handler to be used when executing
		 * @param {function}
		 */
		registerFaultHandler() {}

		/**
		 * @public
		 * @function QueryAPI#registerPostProcessor
		 * @description Register a post processor to process the results on success
		 * @param {function}
		 */
		registerPostProcessor() {}

		/**
		 * @public
		 * @function QueryAPI#registerSaveRawDataHandler
		 * @description Register a handler to receive the raw data results for a query.
		 * @param {function}
		 */
		registerSaveRawDataHandler() {}

		/**
		 * @public
		 * @function QueryAPI#getWarningList
		 * @description Get the list of warnings generated while executing the query
		 * @return {QueryWarning[]}
		 */
		getWarningList() {}
	}

	return QueryAPI;

});
